export const phuketKlookAttractions = {
  'aquaria-phuket':
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1140186&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F26631-aquaria-phuket-ticket%2F',
  'baan-teelanka-maze':
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1140187&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F2391-baan-teelanka-maze-phuket%2F%3Fspm%3DHome.SearchSuggest_LIST%26clickId%3D744570df66',
};
